import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RqaCreateComponent } from './rqa-create/rqa-create.component';
import { SplitterComponent } from 'src/app/ui/splitter/splitter.component';
import { RqaCreateMapComponent } from 'src/app/map/rqa-map/rqa-map.component';
@Component({
  selector: 'rqa-order',
  templateUrl: './rqa-order.component.html',
  styleUrls: ['./rqa-order.component.scss'],
  standalone: true,
  imports: [CommonModule, SplitterComponent]
})
export class RqaOrderComponent {
  leftSideComponent = RqaCreateComponent;
  rightSideComponent = RqaCreateMapComponent;
}
